// import Vue from 'vue'
import { getFirestore, doc, runTransaction } from 'firebase/firestore'
import { getStorage, ref as storageRef, uploadBytes } from 'firebase/storage'
import { getAuth, signOut } from 'firebase/auth'
import router from '@/router'
// import axios from 'axios'
import { uid } from 'uid'


import Vue from "vue"

const initial_state = () => ({ 
    order_bucket: [],
    // parcels: [],
    photos: [],
    orders: [],
    loading_parcels: [],
    fetching_orders: false,
    preloading_bucket: false,
    saving_bucket: false,
    did_check_abandoned: false,
    abandoned_buckets: [],
})

const constant_state = () => ({
  shipments_last_30_days: 0,
  order_count: 0,
  total_remaining_picks: 0,
  starting_amount_picks: 0,
})

const state = {
  ...initial_state(),
  ...constant_state()
}

const is_unauthenticated_error = (e) => {
  return e?.code === 'functions/unauthenticated'
    || e?.code === 'unauthenticated'
    || e?.message === 'User is not authenticated'
}

const handle_unauthenticated_error = async ({ commit, dispatch }, e) => {
  if(!is_unauthenticated_error(e)) return false
  dispatch('app/reset_state', {}, { root: true })
  await signOut(getAuth())
  if(router.currentRoute.path !== '/signin') router.push('/signin').catch(() => {})
  commit('app/SET_SNACK_BAR', 'Your session expired. Please sign in again.', { root: true })
  return true
}


const actions = {
async refetch_parcel({ commit, state, rootState, rootGetters, dispatch }, index){
  commit('SET_STATE', { loading_parcels: state.loading_parcels.concat([index]) } )
  // 1. Re-fetch from server
  //  1A: Ditch order and replace with new, but keep fulfilled_quantity and removed_quantity of each line_item
  try {
    const og_order = state.order_bucket[index]
    const company_uid = rootState.warehouse.current_company_id
    const get_orders = this._vm.$functions.httpsCallable('get_order_bucket')
    const {orders
      // , total_remaining_picks, total_remaining_orders 
    } = await get_orders({
      order_id: og_order.id, 
      line_items: og_order.line_items.map(({
        id,
        fulfillable_quantity,
        fulfilled_quantity,
        removed_quantity,
        sf_total_unfulfilled,
      }) => ({
        id,
        fulfillable_quantity,
        fulfilled_quantity,
        removed_quantity,
        sf_total_unfulfilled,
      })
      ), 
      company_uid,
      data_source_id: og_order.sf_data_source_id
    }).then(orders => orders.data)
    // 1C: Save on vuex state 
    for(const order of orders){
      order.line_items = order.line_items.map(item => {
        item.price = (item.product_id === 7531838406828 ? '39.99' : item.price)
        return {
          ...item,
          sf_quantity_to_fulfill: item.fulfillable_quantity,
          grams: item.grams || rootGetters['product/get_product'](item.uuid)?.grams || 0,
          // TODO rootgetter will fail if product is newly added
        }
      })
      order.total_weight = order.total_weight || order.line_items.reduce((tot, item) => tot + (item.grams * item.fulfillable_quantity), 0)
    }
    commit('SET_ORDER_BUCKET', orders)
    // 2. If applicable, request parcel label and print - see conditions at the end of action "submit_item" in here
    await dispatch('on_check_prints', { order_index: index })
  } catch (e) {
    if(await handle_unauthenticated_error({ commit, dispatch }, e)) return
    throw e
  } finally {
    commit('SET_STATE', { loading_parcels: state.loading_parcels.filter(i => i !== index) } )
  }
},
async set_parcel_error({ state, commit, dispatch }, { index, reset, skip_save, ...err }){
  const parcel = state.order_bucket[index]
  if(!parcel || (reset && !(parcel.errors || []).length)) return
  const errors = reset ? [] : !(parcel.errors || []).some(e => e.message === err.message) ? (parcel.errors || []).concat([err]) : (parcel.errors || [])
  commit('SET_ORDER_ERRORS', { index, errors })
  if(!reset) commit('SET_STATE', { loading_parcels: state.loading_parcels.filter(i => i !== index) } )
  if(!skip_save) await dispatch('save_order_bucket', `set_parcel_error index${index} reset${reset} skip_save${skip_save}`)
},
async remap_shipping_in_order_buckets({ commit }, { ds_id, company_id, exclude }){
  const remap_shipping_in_order_buckets = this._vm.$functions.httpsCallable('remap_shipping_in_order_buckets')
  const remap = await remap_shipping_in_order_buckets({ ds_id, company_id, exclude }).then(res => res.data)
  if(remap.change) commit('SET_ORDER_BUCKET', remap.order_bucket.orders)
},
async get_order_count({ commit, rootState, rootGetters }){
  const should_count_shipments = rootGetters['warehouse/get_plan']?.max_monthly_shipments < Infinity 
  const get_order_count = this._vm.$functions.httpsCallable('get_order_count')
  const { order_count, shipments_last_30_days } = await get_order_count({ company_id: rootState.warehouse.current_company_id, should_count_shipments }).then(res => res.data)
  console.log('shipments_last_30_days', shipments_last_30_days)
  commit('SET_STATE', { order_count, shipments_last_30_days })
},
async recover_bucket({ rootState },{ from_id }){
  const to_id = rootState.user.userProfile.id
  const company_id = rootState.warehouse.current_company_id
  const swap_bucket_id = this._vm.$functions.httpsCallable('swap_bucket_id')
  await swap_bucket_id( { from_id, to_id, company_id } )
},
async get_abandoned_buckets({ rootState, commit }){
  const get_abandoned_buckets = this._vm.$functions.httpsCallable('get_abandoned_buckets')
  const abandoned_buckets = await get_abandoned_buckets({company_id: rootState.warehouse.current_company_id }).then(res => res.data)
  if(!abandoned_buckets.length) commit('SET_STATE', { did_check_abandoned: true })
  else commit('SET_STATE', { abandoned_buckets})
},
 async get_orders({ commit, dispatch, rootState, rootGetters, state }, {hard_refresh, soft_refresh}){
  // Prevent race conditions by checking if preloading is in progress
  if(state.preloading_bucket && !hard_refresh) {
    console.log('Preloading in progress, waiting...')
    // Wait for preloading to complete before proceeding
    await new Promise(resolve => {
      const checkPreloading = () => {
        if(!state.preloading_bucket) {
          resolve()
        } else {
          setTimeout(checkPreloading, 100)
        }
      }
      checkPreloading()
    })
  }

  const company_uid = rootState.warehouse.current_company_id
  const data_source_id = rootState.warehouse.company.data_sources[0]?.id
  commit('SET_FETCHING_ORDERS', true)
  try {
    const get_orders = this._vm.$functions.httpsCallable('get_order_bucket')
    const {orders, total_remaining_picks, total_remaining_orders } = await get_orders({soft_refresh, hard_refresh, company_uid, data_source_id}).then(orders => orders.data)
    for(const order of orders){
      order.line_items = order.line_items.map(item => {
        item.price = +item.price || +rootGetters['product/get_product'](item.uuid)?.price || 20
        //(item.product_id === 7531838406828 ? '39.99' : item.price)
        return {
          ...item,
          sf_quantity_to_fulfill: item.fulfillable_quantity,
          grams: item.grams || rootGetters['product/get_product'](item.uuid)?.grams || 0,
          // TODO rootgetter will fail if product is newly added
        }
      })
      order.total_weight = order.total_weight || order.line_items.reduce((tot, item) => tot + (item.grams * item.fulfillable_quantity), 0)
    }
    if(total_remaining_picks){
      const starting_amount_picks = (state.starting_amount_picks < total_remaining_picks) ? total_remaining_picks : state.starting_amount_picks
      commit('SET_STATE', { total_remaining_picks, starting_amount_picks })
    }
    if(total_remaining_orders) commit('SET_STATE', { order_count: total_remaining_orders })
    commit('SET_ORDER_BUCKET', orders)
  } catch (e) {
    if(await handle_unauthenticated_error({ commit, dispatch }, e)) return
    commit('app/SET_SNACK_BAR', e.message || 'Could not fetch orders', { root: true })
    throw e
  } finally {
    commit('SET_FETCHING_ORDERS', false)
  }
  // dispatch('listen_on_bucket')
  // commit('SET_PICK_ORDER', order_bucket)
 },
 async preload_next_bucket({ commit, dispatch, state, rootState }){
  // Prevent multiple simultaneous preload calls
  if(state.preloading_bucket) {
    console.log('Preloading already in progress, skipping...')
    return
  }

  // Wait for any ongoing save operations to complete before preloading
  if(state.saving_bucket) {
    console.log('Save operation in progress, waiting before preloading...')
    await new Promise(resolve => {
      const checkSaving = () => {
        if(!state.saving_bucket) {
          resolve()
        } else {
          setTimeout(checkSaving, 50)
        }
      }
      checkSaving()
    })
  }

  try {
    commit('SET_STATE', { preloading_bucket: true })
    const company_uid = rootState.warehouse.current_company_id
    const get_order_bucket = this._vm.$functions.httpsCallable('get_order_bucket')
    const result = await get_order_bucket({
      company_uid,
      preload: true
    }).then(res => res.data)
    console.log('Preload result:', result)
    return result
  } catch (e) {
    console.error('Error preloading bucket:', e)
    if(await handle_unauthenticated_error({ commit, dispatch }, e)) return null
    throw e
  } finally {
    commit('SET_STATE', { preloading_bucket: false })
  }
 },
async check_bucket_inventory({ getters, dispatch, rootGetters }){
  const products_to_check = getters.get_pick_order
    .filter(item => item.last_pick || !rootGetters['product/get_product'](item.uuid))
    .map(item => item.uuid)
  if(!products_to_check.length) return
  await dispatch('product/get_specific_products', { uuids: products_to_check }, {root: true })
    // const refresh_products = this._vm.$functions.httpsCallable('refresh_products')
    // const products = await refresh_products({ uuids: products_to_check, company_uid: rootState.warehouse.current_company_id }).then(res => res.data)
    // commit('product/UPDATE_PRODUCTS', products, {root: true})
},
 async fulfill_parcel({ state, dispatch, commit, rootState }, {index, seconds_spent}){
  commit('SET_STATE', { loading_parcels: state.loading_parcels.concat([index]) } )
  const parcel = state.order_bucket[index]
  // const order_uid = parcel.uuid
  if(index < (state.order_bucket.length - 1)){
    Vue.set(state.order_bucket, index, { 
      ...state.order_bucket[index], 
      sf_fulfilled: true,
    })
  }
  const available_until_d = new Date().setDate(new Date().getDate() + 48)
  const available_until = new Date(available_until_d).toISOString()
  parcel.seconds_spent = seconds_spent || 0
  parcel.sf_label_refs = parcel.sf_data.labels.map(p => {
    return {
      type: p.description, 
      media: p.media, 
      available_until,
      ref: p.ref,
      tracking_number: p.tracking_number || null,
    }
  })
  parcel.sf_photo_refs = (state.photos[index] || []).map(() => {
    return {
      available_until,
      ref: `data_sources/${parcel.sf_data_source_id}/fulfillment_photos/${uid(24)}.jpeg`
    }
  })
  // Customs invoices saved by the carrier integration (currently FedEx only)
  parcel.sf_invoice_refs = [...new Set(parcel.sf_data.labels.map(p => p.invoice_ref).filter(Boolean))]
    .map(ref => ({ available_until, ref }))

  if(parcel.sf_data?.shipping_service) parcel.sf_data.shipping_service.carrier_tracking_url_pattern = rootState.app.config.carriers[
    rootState.warehouse.company.carriers.find(carrier => carrier.id === parcel.sf_data.shipping_service.sf_carrier_account_id).type
  ]?.carrier_tracking_url_pattern || parcel.sf_data.shipping_service.carrier_tracking_url_pattern || ''

  const fulfill_parcel = this._vm.$functions.httpsCallable('fulfill_parcel')
  const [{ fulfillment, fulfillments }, ] = await Promise.all([
    fulfill_parcel({ parcel })
    .then(res => res.data)
    .catch(e => {
      Vue.set(state.order_bucket, index, { 
        ...state.order_bucket[index], sf_fulfilled: false
      })
      dispatch('app/submit_error', { e, within: 'fulfill_parcel', text: `ORDER: \n${JSON.stringify(parcel, undefined, 3)}`}, {root: true})
      throw new Error(e)})
      ,
      // parcel.sf_label_refs.map((p, parcel_index) => {
      //   if(state.parcels[index][parcel_index] && state.parcels[index][parcel_index].data){
      //     return firebase.storage().ref().child(p.ref).put(state.parcels[index][parcel_index].data)
      //   } else return null
      // }),
      parcel.sf_photo_refs.map((p, photo_index) => { // ÄR INTE DETTA FEL?? 2025-04
        const ref = storageRef(getStorage(), p.ref)
        return uploadBytes(ref, state.photos[index][photo_index])
      })
  ])
  commit('SET_STATE', { loading_parcels: state.loading_parcels.filter(i => i !== index) } )
  console.log('fulfillment', fulfillment)
  if(!fulfillment) return
  Vue.set(state.order_bucket, index, { 
    ...state.order_bucket[index], sf_fulfilled: true
  })
  const ds_id = parcel.sf_data_source_id
  commit('fulfillments/UNSHIFT_PARCEL', { ...fulfillment, sf_ds_id: ds_id }, { root: true })
  const order_count = state.order_count - 1
  const shipments_last_30_days = state.shipments_last_30_days + 1
  commit('warehouse/SET_DATA_SOURCE', { id: ds_id, fulfillments }, { root: true })
  commit('SET_STATE', { shipments_last_30_days })
  if(order_count > -1) commit('SET_STATE', { order_count })
  await dispatch('save_order_bucket', 'fulfill_parcel') // PROBLEM om user tar foto på nästa order innan denna slår in ELLER label skrivs ut osv som sparar över order_bucket
 },
 // Deletes a booked label from an unfulfilled order in the bucket. All labels belonging to the
 // shipment (the label itself and any customs doc) are removed once the carrier confirms.
 async delete_label({ state, commit, dispatch }, { index, tracking_number }){
  const order = state.order_bucket[index]
  const labels = order.sf_data.labels || []
  const shipment_labels = labels.filter(l => !l.tracking_number || l.tracking_number === tracking_number)
  const deleted = await dispatch('warehouse/delete_label', {
    carrier_id: order.sf_data.shipping_service.sf_carrier_account_id,
    tracking_number,
    label_refs: shipment_labels.map(l => l.ref),
  }, { root: true })
  if(!deleted) return false
  commit('SET_SF_DATA', { index, data: { labels: labels.filter(l => !shipment_labels.includes(l)) } })
  await dispatch('save_order_bucket', 'delete_label')
  return true
 },
 async check_parcel_fulfilled({ state, dispatch }, index){
  const parcel = state.order_bucket[index]
  const order_uid = parcel.uuid
  const get_one_order = this._vm.$functions.httpsCallable('get_one_order')
  const order = await get_one_order({ order_uid }).then(res => res.data)
  const unfulfilled = parcel.line_items.reduce((tot, item) => {
    const new_item = order.line_items.filter(i => i.id === item.id)[0]
    if(!new_item) return tot
    return tot += (new_item.fulfillable_quantity - item.removed_quantity)
  }, 0)
  if(unfulfilled) dispatch('set_parcel_error', {
    index,
    message: `${unfulfilled} line items in this order are unfulfilled in your store. Fulfill in Shopify to proceed.`,
    type: 'warning'
  })
  else {
    Vue.set(state.order_bucket, index, { 
      ...state.order_bucket[index], sf_fulfilled: true
    })
    dispatch('save_order_bucket')
  }
 },
 async drop_parcel({ state, dispatch }, index){
  Vue.set(state.order_bucket, index, { 
    ...state.order_bucket[index], sf_dropped: true
  })
  const order = state.order_bucket[index]
  if(order.sf_data.shipping_service && order.sf_data.shipping_service.type === 'shopify' && order.sf_data.labels.length){
    const void_shopify_label = this._vm.$functions.httpsCallable('void_shopify_label')
    void_shopify_label({ shopify_label_id: order.sf_data.labels[0].shopify_label_id, data_source_id: order.sf_data_source_id })
  }
  await dispatch('save_order_bucket', 'drop_parcel')
  // dispatch('block_order', index)
 },
 async block_order({ rootState, state, commit }, { index, reason }){
  const block_order = this._vm.$functions.httpsCallable('block_order')
  const company_uid = rootState.warehouse.current_company_id
  const order = state.order_bucket[index]
  // Use custom reason if provided, otherwise fall back to existing error messages
  const message = reason || '' // (order.errors || []).map(e => e.message).join(', ')
  const data_source_id = order.sf_data_source_id
  const blocked_orders = await block_order({order, company_uid, message, data_source_id}).then(res => res.data)
  if(blocked_orders) commit('warehouse/SET_DATA_SOURCE', { id: data_source_id, blocked_orders }, {root: true})
 },
 async submit_item({ getters, state, dispatch, commit }, { index, seconds_spent }){
  const bucket = getters.get_pick_order[index]
  const total_picks = bucket.orders.reduce((tot, order) => tot + order.quantity - order.removed_quantity, 0)
  let picked_items = 0
  const promises = []
  for(const order of bucket.orders){
    const order_index = state.order_bucket.findIndex(i => i.uuid === order.order_uuid)
    // console.log(state.order_buckets.filter(i => i.uuid === order.order_uuid).length)
    state.order_bucket[order_index].line_items.forEach(item => {
      if(item.product_id === bucket.product_id && item.variant_id === bucket.variant_id && item.id === order.line_item_id){
        // item.fulfillable_quantity -= order.quantity
        item.fulfilled_quantity += (order.quantity - order.removed_quantity)
        item.seconds_spent = Math.round((seconds_spent * ((order.quantity - order.removed_quantity) / total_picks)) * 100) / 100
        picked_items += (order.quantity - order.removed_quantity)
      }
    })
    commit('DEDUCT_PICKS', picked_items)
    commit('SET_ORDER_BUCKET', state.order_bucket)
    const promise = dispatch('on_check_prints', { order_index })
    if(promise) promises.push(promise)
  }
  console.log('promises', promises)
  await Promise.all(promises)
  await dispatch('save_order_bucket', 'submit_item')
 },
 on_check_prints({  state, commit, dispatch, rootState, rootGetters }, { order_index }){
      if(
      rootGetters['warehouse/get_label_generation_mode'] === 'on_picked'
      && !state.order_bucket[order_index].line_items.some(item => item.fulfillable_quantity - item.fulfilled_quantity - item.removed_quantity)
      && state.order_bucket[order_index].line_items.some(item => item.fulfilled_quantity
      && !(
        state.order_bucket[order_index].line_items.some(item => item.removed_quantity && !item.override_parcel_block) 
        && !rootState.warehouse.company.data_sources.find(ds => ds.id === state.order_bucket[order_index].sf_data_source_id).allow_partial_fulfillment
      )
      && state.order_bucket[order_index].shipping_lines.length 
      && state.order_bucket[order_index].sf_data.shipping_service
      && !state.order_bucket[order_index].sf_data.labels?.length
      )
    ) {
      console.log('requesting print on ', state.order_bucket[order_index].name)
      return new Promise(resolve => {
        console.log('in promise')
        commit('SET_STATE', { loading_parcels: state.loading_parcels.concat([order_index]) } )
        dispatch('warehouse/request_parcel',{ index: order_index, is_silent: true }, { root: true }).then(async () => {
          if(order_index === 0) await dispatch('warehouse/request_print', order_index, { root: true })
          commit('SET_STATE', { loading_parcels: state.loading_parcels.filter(i => i !== order_index )})
          return resolve()
        })
      })
    }
    return null
 },
 remove_item({ state, dispatch, rootState, commit }, {order, item, reason, override_default, amount }){
   console.log('remove_item, ORDER:', order)
   let picked_items = 0
  const order_b = state.order_bucket[state.order_bucket
    .findIndex(i => i.uuid === order.order_uuid)]
    const data_source = rootState.warehouse.company.data_sources.filter(ds => ds.id === order_b.sf_data_source_id)[0]
    const allow_partial_fulfillment = override_default ? !data_source.allow_partial_fulfillment : data_source.allow_partial_fulfillment;
    order_b.line_items.forEach(i => {
    // om bolaget inte tillåter partial fulfillment - ta bort allt!
    if(!allow_partial_fulfillment){
      i.removed_quantity = i.fulfillable_quantity
      i.override_parcel_block = override_default
      picked_items += i.fulfillable_quantity
    } else if(i.uuid === item.uuid) {
      i.removed_quantity += amount
      i.override_parcel_block = override_default
      picked_items += amount
    }
  })
  commit('DEDUCT_PICKS', picked_items)
  dispatch('save_order_bucket')
  dispatch('block_item', { item, data_source_id: data_source.id, reason })
 },
 // Centralized function to handle database writes with retry logic for transaction conflicts
 async _updateOrderBucketWithRetry({ rootState }, { updateFunction, operationName }) {
  const db = getFirestore()
  const company_ref = doc(db, 'companies', rootState.warehouse.current_company_id)
  
  // Implement retry logic for transaction conflicts
  const maxRetries = 3
  let retryCount = 0
  
  while (retryCount < maxRetries) {
    try {
      await runTransaction(db, async t => {
        const snap = await t.get(company_ref)
        const company = snap.data()
        const bucket = company.order_buckets
          .filter(bucket => bucket.user_id === rootState.user.user.uid && bucket.started_at)[0]  
          
        if (!bucket) {
          console.warn(`No working bucket found for user, skipping ${operationName}`)
          return
        }
        
        // Call the custom update function
        await updateFunction(bucket, company, t, company_ref)
      })
      
      console.log(`done ${operationName}`)
      return // Success, exit retry loop
      
    } catch (e) {
      retryCount++
      console.log(`Error in ${operationName} (attempt ${retryCount}/${maxRetries}):`, e.message)
      
      // If it's a transaction conflict and we have retries left, wait and retry
      if (e.code === 'aborted' && retryCount < maxRetries) {
        console.log(`Transaction conflict detected, retrying in ${retryCount * 100}ms...`)
        await new Promise(resolve => setTimeout(resolve, retryCount * 100))
        continue
      }
      
      // If it's a document size error (400 Bad Request), try to clean up the bucket
      if (e.message.includes('400') || e.message.includes('Bad Request')) {
        console.warn(`Document size limit reached in ${operationName}, this may indicate the order bucket is too large`)
        // Log the error but don't retry as it's likely a document size issue
        console.error(`Document size error in ${operationName}:`, e.message)
        // You might want to trigger a bucket refresh here to get a smaller bucket
        throw new Error(`Document too large - bucket may need to be refreshed. Original error: ${e.message}`)
      }
      
      // If it's not a transaction conflict or we're out of retries, throw the error
      console.error(`Failed ${operationName} after retries:`, e)
      throw e
    }
  }
 },

 async save_order_bucket({ rootState, state, dispatch, commit }, from){
  console.log('saveOrderBucket', from)
  console.log('STATE', state.order_bucket)
  
  try {
    commit('SET_STATE', { saving_bucket: true })
    await dispatch('_updateOrderBucketWithRetry', {
      updateFunction: (bucket, company, t, company_ref) => {
        console.log('company.order_bucket', company.order_buckets)
        console.log('bucket', bucket)
        
        bucket.orders = state.order_bucket
        bucket.last_updated_at = new Date().toISOString()
        bucket.total_remaining_picks = state.total_remaining_picks
        
        // Only remove the current working bucket, preserve preloaded buckets
        const set = { order_buckets: company.order_buckets.filter(b => 
          !(b.user_id === rootState.user.user.uid && b.started_at)
        ).concat(bucket) }
        t.update(company_ref, set)
      },
      operationName: `saveOrderBucket_${from}`
    })
  } finally {
    commit('SET_STATE', { saving_bucket: false })
  }
 },
 async block_item({ rootState, commit }, { item, data_source_id, reason }){
  const block_item = this._vm.$functions.httpsCallable('block_item')
  const company_uid = rootState.warehouse.current_company_id
  const blocked_items = await block_item({item, company_uid, data_source_id, reason }).then(res => res.data)
  // if(blocked_items.data) commit('warehouse/SET_COMPANY', {blocked_items: blocked_items.data}, {root: true})
  if(blocked_items) commit('warehouse/SET_DATA_SOURCE', { id: data_source_id, blocked_items }, { root: true })
 },
 async refresh_order_bucket({ commit, rootState, dispatch }, { hard_refresh = false } = {}){
  commit('RESET_STATE')
  const company_uid = rootState.warehouse.current_company_id
  // If hard_refresh is explicitly requested, bypass preloaded buckets
  // Otherwise, try to use preloaded buckets first
  await dispatch('get_orders', { hard_refresh, company_uid, soft_refresh: !hard_refresh })
 },
}

const mutations = {
  DEDUCT_PICKS(state, amount){
    const picks = state.total_remaining_picks - amount
    Vue.set(state, 'total_remaining_picks', picks < 0  ? 0 : picks)
  },
  SET_ORDER_BUCKET(state, payload){
    Vue.set(state, 'order_bucket', payload)
  },
  SET_ORDER_ERRORS(state, { index, errors }){
    console.log(index, errors)
    if(!state.order_bucket[index]) return
    Vue.set(state.order_bucket[index], 'errors', errors)
  },
  SET_ORDER(state, { index, key, value }){
    // const [ first, second ] = key.split('.')
    // Vue.set(state.order_bucket[index][first], second, value )
    console.log(state.order_count)
    const keys = key.split('.')
    const final_key = keys.splice(-1)
    if(eval(`state.order_bucket[${index}].${keys.join('.')}.${final_key}`) instanceof Array) {
      eval(`state.order_bucket[${index}].${keys.join('.')}.${final_key}`).push(value)
    } 
    else Vue.set(eval(`state.order_bucket[${index}].${keys.join('.')}`), final_key, value)
  },
  SET_LINE_ITEM(state, { index, item_index, line_item }){
    if(!state.order_bucket[index] || !state.order_bucket[index].line_items) return
    Vue.set(state.order_bucket[index].line_items, item_index, line_item)
  },
  SET_STATE(state, payload){
    for(const key in payload){
      Vue.set(state, key, payload[key])
    }
  },
  SET_LOADING_PARCEL(state, {index, done}){
    Vue.set(state, 'loading_parcels', done ? state.loading_parcels.filter(s => s !== index ): state.loading_parcels.concat([index]))
  },
  SET_SF_DATA(state, payload){
    Vue.set(state.order_bucket, payload.index, {
      ...state.order_bucket[payload.index],
      sf_data: {
          ...state.order_bucket[payload.index].sf_data,
          ...payload.data,
      }
    })
  },
  // SET_ORDER_IN_BUCKET(state, { order_index, ...payload}){
  //   Vue.set(state.order_)
  // },
  REMOVE_PHOTO(state, {order_index, photo_index}){
    // const x = state.photos[order_index]
    // x.
    state.photos[order_index].splice(photo_index, 1)
  },
  SET_PHOTOS(state, payload){
    const x = (state.photos[payload.order_index] || []).concat([payload.photo])
    // x[payload.parcel_index] = payload
    Vue.set(state.photos, payload.order_index, 
      x
      )
  },
  SET_FETCHING_ORDERS(state, e){
    Vue.set(state, 'fetching_orders', e)
  },
  RESET_STATE(state){
    for(const key in initial_state()){
      Vue.set(state, key, initial_state()[key])
    }
  }
}

const getters = {
  get_pick_order: (state, getters) => {
    // const shelves = rootState.warehouse.shelves
    const items = state.order_bucket
      .reduce((tot, order) => tot.concat(...order.line_items
        .filter(item => {
          if(!item.fulfillable_quantity) return false
          if(tot.findIndex(i => i.uuid === item.uuid) !== -1){
            tot[tot.findIndex(i => i.uuid === item.uuid)].orders.push({ 
              line_item_id: item.id,
              order_uuid: order.uuid, 
              quantity: item.fulfillable_quantity, 
              fulfilled_quantity: item.fulfilled_quantity || 0,
              removed_quantity: item.removed_quantity,
              active: !!(item.fulfillable_quantity - item.fulfilled_quantity - item.removed_quantity),
              sf_fulfilled: !!order.sf_fulfilled,
            })
            return false
          }
          return true
        })
        .map(item => {
          return {
          ...item,
          orders:[{ 
            line_item_id: item.id,
            order_uuid: order.uuid, 
            quantity: item.fulfillable_quantity,
            fulfilled_quantity: item.fulfilled_quantity || 0,
            removed_quantity: item.removed_quantity,
            active: ((item.fulfillable_quantity - item.fulfilled_quantity - item.removed_quantity) > 0),
            sf_fulfilled: !!order.sf_fulfilled,
          }],
        }})), [])
      .filter(item => item && (item.fulfillment_status === null || item.fulfillment_status === 'partial'))
      .map(item => {
        const { uuid, name, orders, product_id, variant_id } = item
        const last_pick = orders.reduce((tot, order) => tot + order.quantity, 0) === item.sf_total_unfulfilled
        // Units that leave the shelf in this bucket but are still committed in Shopify
        // (removed units stay on the shelf, fulfilled parcels are already deducted by Shopify)
        const picked_quantity = orders
          .filter(order => !order.sf_fulfilled)
          .reduce((tot, order) => tot + order.quantity - (order.removed_quantity || 0), 0)
        const position = getters.get_item_position(uuid)
        return {
          uuid,
          name, 
          orders,
          position,
          product_id,
          variant_id,
          last_pick,
          picked_quantity,
        }
      })
      .sort((a, b) => {
        if(!a.position) return 1
        if(!b.position) return -1
        else if(a.position.shelve_index < b.position.shelve_index){ return -1 }
        else if(a.position.shelve_index > b.position.shelve_index) { return 1 }
        else {
          if(a.position.shelf < b.position.shelf){ return -1}
          else if(a.position.shelf > b.position.shelf){ return 1}
          else {
            if(a.position.slot < b.position.slot) return -1
            else if(a.position.slot > b.position.slot) return 1
            else {
              if(a.position.product < b.position.product) return -1
              else if(a.position.product > b.position.product) return 1
              else return 0
            }
          }
        }
      })
      return items
  },
  // What should physically be left on the shelf once this bucket's units of the item are
  // picked: Shopify on hand minus the units this bucket takes. Null when the product is unknown.
  get_expected_shelf_quantity: (state, getters, rootState, rootGetters) => uuid => {
    const on_hand = rootGetters['product/get_inventory_on_hand'](uuid)
    if(on_hand === null) return null
    const item = getters.get_pick_order.find(i => i.uuid === uuid)
    return on_hand - (item?.picked_quantity || 0)
  },
  get_item_position: (state, getters, rootState) => (uuid) => {
    const shelves = rootState.warehouse.shelves
    for(const shelve in shelves){
      for(const shelf in shelves[shelve].shelfs){
        for(const slot in shelves[shelve].shelfs[shelf].slots){
          for(const product in shelves[shelve].shelfs[shelf].slots[slot].products){
            
            if(shelves[shelve].shelfs[shelf].slots[slot].products[product].uid === uuid) return {
              shelve: shelves[shelve].name || +shelve + 1,
              shelve_index: +shelve,
              shelf: parseInt(shelf),
              slot: parseInt(slot),
              product: parseInt(product),
              printed: shelves[shelve].shelfs[shelf].slots[slot].products[product].printed,
              shelf_code: shelves[shelve].shelfs[shelf].slots[slot].products[product].shelf_code,
            }
          }
        }
      }
    }

    return null
  },
  get_order_bucket_position: (state) => (uuid) => {
    return state.order_bucket.findIndex(order => order.uuid === uuid)
  },
  get_current_item: (state, getters) => {
    if(!state.order_bucket || !state.order_bucket.length) return 0
    const index = getters.get_pick_order.findIndex(i => 
      i.orders.some(order => order.active)
    )
    return index
  },
  get_current_parcel_card: (state, getters) => {
    if(getters.get_current_item !== -1) return null
    return state.order_bucket.findIndex(a => !a.sf_fulfilled && !a.sf_dropped && a.line_items.some(item => item.fulfilled_quantity))
  },
  // get_printable_orders: (state, getters, rootState) => {
  //   const printable = state.order_bucket.filter(order => {
  //     const data_source = rootState.warehouse.company.data_sources.filter(ds => ds.id === order.sf_data_source_id)[0]
  //     if(!order.line_items.some(item => item.fulfilled_quantity)) return false
  //     if(data_source.allow_partial_fulfillment) return true
  //     if(order.line_items
  //       .some(item => rootState.warehouse.company.blocked_items
  //         .some(blocked => blocked.item_uuid === item.uuid)
  //       )) return false
  //     return true 
  //   })
  //   return printable
  // },
  // get_parcel_errors: (state) => (index) => {
  //   return state.errors.filter(err => err.index === index)
  // },
  get_return_items: (state, getters) => {
    return state.order_bucket.filter(order => order.sf_dropped)
      .reduce((tot, order) => tot.concat(
        order.line_items
          .filter(item => item.fulfilled_quantity))
      , [])
      .map(item => ({
        ...item,
        sf_position: getters.get_item_position(item.uuid)
      }))
      .sort((a,b) => !a.sf_position ? 1 : 
                    !b.sf_position ? -1 : a.sf_position.shelve - b.sf_position.shelve)
  },
  get_data_source_by_bucket_order: (state, getters, rootState) => order_uuid => {
    const order_b = state.order_bucket[state.order_bucket
      .findIndex(i => i.uuid === order_uuid)]
      const data_source = rootState.warehouse.company.data_sources.find(ds => ds.id === order_b.sf_data_source_id)
      return data_source
  },
  get_order_by_uuid: (state) => order_uuid => {
    return state.order_bucket
      .find(i => i.uuid === order_uuid)
  }
}

export default {
    state,
    getters,
    actions, 
    mutations,
    namespaced: true,
}
